import React, { memo } from 'react'
import { Moment } from 'moment-timezone'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { NowHead } from './Now'

interface CalendarHeadDayPinProps {
  label: string
}

export const CalendarHeadDayPin = memo<CalendarHeadDayPinProps>(({ label }) => (
  <div>
    <span>{label}</span>
  </div>
))

interface CalendarHeadDayProps {
  day: Moment
  nbOfHours: number
}

export const CalendarHeadDay = memo<CalendarHeadDayProps>(({ day, nbOfHours }) => {
  const { isMobile } = useBreakpointContext()
  const TODAY = new Date()
  const isToday = day.isSame(TODAY, 'day')
  return (
    <div className='calendar-view-day-column'>
      <div className={`calendar-view-date ${isToday ? 'current-date' : ''}`}>
        <div className='day'>{day.format('ddd')}</div>
        <div className='date'>{day.format('D')}</div>
      </div>
      <div className='calendar-view-time'>
        {/* Display houly pin when only displaying one day, otherwise use 3 hours increment */}
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='1a' />}
        {nbOfHours > 3 && <CalendarHeadDayPin label='2a' />}
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='3a' />}
        {nbOfHours > 3 && <CalendarHeadDayPin label='4a' />}
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='5a' />}
        <CalendarHeadDayPin label='6a' />
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='7a' />}
        {nbOfHours > 3 && <CalendarHeadDayPin label='8a' />}
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='9a' />}
        {nbOfHours > 3 && <CalendarHeadDayPin label='10a' />}
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='11a' />}
        <CalendarHeadDayPin label='12p' />
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='1p' />}
        {nbOfHours > 3 && <CalendarHeadDayPin label='2p' />}
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='3p' />}
        {nbOfHours > 3 && <CalendarHeadDayPin label='4p' />}
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='5p' />}
        <CalendarHeadDayPin label='6p' />
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='7p' />}
        {nbOfHours > 3 && <CalendarHeadDayPin label='8p' />}
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='9p' />}
        {nbOfHours > 3 && <CalendarHeadDayPin label='10p' />}
        {!isMobile && nbOfHours > 3 && <CalendarHeadDayPin label='11p' />}
        <CalendarHeadDayPin label='' />
      </div>
      {isToday && <NowHead />}
    </div>
  )
})

interface ICalendarHeadProps {
  days: Moment[]
}

export const CalendarHead = memo<ICalendarHeadProps>(({ days }) => {
  // If displaying > 1 day, only display 3 hours indicators
  const nbOfDisplayedHours = days.length > 1 ? 3 : 24
  return (
    <div className='calendar-view-head'>
      <div className='calendar-view-legend-column' />
      {days.map(day => (
        <CalendarHeadDay day={day} nbOfHours={nbOfDisplayedHours} key={day.valueOf()} />
      ))}
    </div>
  )
})
